import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AccountCancellationResponse } from "src/app/models/user/accountCancellationResponse";
import { DMVStoreService } from "src/app/services/dmv/dmv-store.service";
import { GlobalService } from "src/app/services/global/global.service";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";
import { USERDataService } from "src/app/services/user/user-data.service";
import { USERStoreService } from "src/app/services/user/user-store.service";
import { AppUtil } from "src/app/utils/app.util";

@Component({
	selector: "app-enrollment",
	templateUrl: "./enrollment.component.html",
	styleUrls: ["./enrollment.component.css"]
})
export class EnrollmentComponent implements OnInit {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService,
		public megStoreService: MEGStoreService,
		public userStoreService: USERStoreService,
		public userDataService: USERDataService,
		public dataRoute: ActivatedRoute,
		private cd: ChangeDetectorRef
	) {}
	public errorMessage = null;
	public isloading: boolean = false;
	public isEnrollCancel: boolean;
	public cancellationData: AccountCancellationResponse;
	public cancellationToken: boolean = false;
	ngOnInit() {
		this.globalService.cancellationToken$().subscribe(val => {
			this.cancellationToken = val;

			this.cd.detectChanges();
		});
		this.cancellationData = this.dataRoute.snapshot.params.data
			? JSON.parse(this.dataRoute.snapshot.params.data)
			: {};
		if (this.dataRoute.snapshot.params.type === "true") {
			this.isEnrollCancel = true;
		} else {
			this.isEnrollCancel = false;
		}
	}

	public continue() {
		if (this.isEnrollCancel) {
			this.userStoreService.setUserProfile(null);
			this.dmvStoreService.addToProfileState = undefined;
			this.router.navigate(["home"], { skipLocationChange: true });
		} else {
			this.router.navigate(["contact-info"], { skipLocationChange: true });
		}
	}
}
